// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Modal$OrcaPaymentPage from "../Components/Modal.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";

function getKeyValue(json, str) {
  return Core__Option.getOr(Core__JSON.Decode.string(Core__Option.getOr(json[str], {})), "");
}

function BankTransfersPopup(props) {
  let match = React.useState(() => []);
  let setKeys = match[1];
  let keys = match[0];
  let match$1 = React.useState(() => ({}));
  let setJson = match$1[1];
  let json = match$1[0];
  let match$2 = React.useState(() => ({}));
  let setPostData = match$2[1];
  let postData = match$2[0];
  let match$3 = React.useState(() => "");
  let setReturnUrl = match$3[1];
  let return_url = match$3[0];
  let match$4;
  switch (props.transferType) {
    case "achBankTransfer" :
      match$4 = [
        "ach_credit_transfer",
        "ACH"
      ];
      break;
    case "bacsBankTransfer" :
      match$4 = [
        "bacs_bank_instructions",
        "BACS"
      ];
      break;
    case "sepaBankTransfer" :
      match$4 = [
        "sepa_bank_instructions",
        "SEPA"
      ];
      break;
    default:
      match$4 = [
        "",
        ""
      ];
  }
  let responseType = match$4[0];
  let match$5 = React.useState(() => false);
  let setIsCopied = match$5[1];
  let isCopied = match$5[0];
  let match$6 = React.useState(() => false);
  let setOpenModal = match$6[1];
  let match$7 = React.useMemo(() => {
    if (isCopied) {
      return [
        JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
              name: "ticMark",
              size: 22
            }),
            "Copied"
          ]
        }),
        "text-[#c0c0c0] font-medium "
      ];
    } else {
      return [
        JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
              name: "copyIcon",
              size: 22
            }),
            "Copy"
          ]
        }),
        "text-[#006DF9]"
      ];
    }
  }, [isCopied]);
  React.useEffect(() => {
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    let handle = ev => {
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
        return;
      }
      let metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
      let dictMetadata = Utils$OrcaPaymentPage.getDictFromJson(Core__Option.getOr(Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata"))[responseType], {}));
      setKeys(param => Object.keys(dictMetadata));
      setJson(param => dictMetadata);
      setPostData(param => Utils$OrcaPaymentPage.getJsonObjectFromDict(Utils$OrcaPaymentPage.getDictFromJson(metadata), "data"));
      setReturnUrl(param => Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(metadata), "url", ""));
    };
    window.addEventListener("message", handle);
    return () => {
      window.removeEventListener("message", handle);
    };
  }, []);
  return JsxRuntime.jsx(Modal$OrcaPaymentPage.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
                name: "ach-transfer",
                size: 45
              }),
              className: "PopupIcon m-1 p-2"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("span", {
                children: match$4[1] + ` bank transfer`,
                className: "font-bold text-lg"
              }),
              className: "Popuptitle flex w-[90%] justify-center"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("span", {
                children: "Use these details to transfer amount",
                className: "font-medium text-sm text-[#151A1F] opacity-50"
              }),
              className: "PopupSubtitle w-[90%] text-center"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("span", {
                      children: "Bank Account Details",
                      className: "text-[#151a1fe6]"
                    }),
                    JsxRuntime.jsx("button", {
                      children: match$7[0],
                      className: `flex flex-row ` + match$7[1] + ` cursor-pointer`,
                      onClick: param => {
                        let text = keys.map(item => Utils$OrcaPaymentPage.snakeToTitleCase(item) + ` : ` + getKeyValue(json, item)).join(`\n`);
                        Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                          [
                            "copy",
                            true
                          ],
                          [
                            "copyDetails",
                            text
                          ]
                        ]);
                        setIsCopied(param => true);
                      }
                    })
                  ],
                  className: "flex font-medium p-5 justify-between text-sm",
                  style: {
                    borderBottom: "1px dashed rgba(21, 26, 31, 0.06)"
                  }
                }),
                JsxRuntime.jsx("div", {
                  children: keys.map(item => JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                          children: Utils$OrcaPaymentPage.snakeToTitleCase(item) + ` : `,
                          className: "text-[#151A1F] font-medium opacity-60"
                        }),
                        JsxRuntime.jsx("span", {
                          children: getKeyValue(json, item),
                          className: "text-[#151A1F] font-semibold opacity-80"
                        })
                      ]
                    }),
                    className: "flex px-5 pb-5 justify-between text-sm"
                  })),
                  className: "Details pt-5"
                })
              ],
              className: "DetailsSection w-full m-8 text-center",
              style: {
                background: "rgba(21, 26, 31, 0.03)",
                border: "1px solid rgba(21, 26, 31, 0.06)",
                borderRadius: "5px"
              }
            })
          ],
          className: "flex flex-col w-full mt-4 max-w-md justify-between items-center"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: " Please make a note of these details, before closing this popup. You will not be able to generate this details again. ",
              className: "Disclaimer w-full mt-16 font-medium text-xs text-[#151A1F] opacity-50"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("button", {
                  children: "Done",
                  className: "w-full mt-6 p-2 h-[40px]",
                  style: {
                    background: "#006DF9",
                    borderRadius: "4px",
                    color: "#ffffff"
                  },
                  onClick: param => {
                    Utils$OrcaPaymentPage.postSubmitResponse(postData, return_url);
                    Modal$OrcaPaymentPage.close(setOpenModal);
                  }
                })
              }),
              className: "button w-full"
            })
          ],
          className: " flex flex-col max-w-md justify-between items-center"
        })
      ],
      className: "flex flex-col h-full justify-between items-center"
    }),
    showClose: false,
    setOpenModal: setOpenModal,
    openModal: match$6[0]
  });
}

let make = BankTransfersPopup;

export {
  getKeyValue,
  make,
}
/* react Not a pure module */
